import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";


const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
var Packed_From_Date_val;
var Packed_to_Date_val;



const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xls';

const exportToCSV = (csvData, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [['Warehouse', 'Client', 'Invoice Number', 'Trip Id', "Bill Number", 'SRN Date','Confirm Datetime', 'Product Code', 'Product Name', 'MRP', 'Return qty- Landed', 'Return qty- Received', 'Return qty- Putaway Done', 'Return qty- GR Done', 'Return qty- GR value', 'Tax Amount', 'Tax %', 'Taxable Value', 'Retailer Name', 'Retailer Code', 'Return value'
  ]];
  //  const Heading = [['Warehouse', 'Client', 'Invoice Number', 'Trip Id', "Bill Number", 'SRN Date', 'Product Code', 'Product Name', 'MRP', 'Return qty- Landed', 'Return qty- Received', 'Return qty- Putaway Done', 'Return qty- GR Done', 'Return qty- GR value', 'Tax Amount', 'Tax %', 'Taxable Value', 'Retailer Name', 'Retailer Code', 'Return value'
  // ]];
  const ws = XLSX.utils.json_to_sheet(csvData, { origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xls', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchSalesData = this.fetchSalesData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);
    this.downloadReport = this.downloadReport.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      warehouseData: [],
      clientData: [],
      brand_code: "",
      warehouse_code: "",
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no: "",
      trip_id: "",
      product_code: "",

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      from_date: "",
      to_date: "",
      packedfromdate:"",
      packedtodate:"",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData: [],
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: "" 

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
    this.fetchWarehouseData();
    this.fetchBrandData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {

    this.setState({
      from_date: date,
      showFromErr: false,
      packedfromdate: "",
      packedtodate:""

    })
    if (date) {
      From_Date_val = this.convertDate(date);
      Packed_From_Date_val = "";
    Packed_to_Date_val = "";
    } else {
      this.setState({
        from_date: ""
      })
      From_Date_val = "";
      Packed_From_Date_val = "";
    Packed_to_Date_val = "";
    }


  }

  ToDateChange = date => {
    
    this.setState({
      to_date: date,
      showToErr: false,
      packedfromdate: "",
      packedtodate:""
    })
    if (date) {
      to_Date_val = this.convertDate(date);
      Packed_From_Date_val = "";
    Packed_to_Date_val = "";
    } else {
      this.setState({
        to_date: "",

      })
      to_Date_val = "";
      Packed_From_Date_val = "";
    Packed_to_Date_val = "";
    }

  }
  PackedFromDateChange = date => {
    
    this.setState({
      packedfromdate: date,
      showFromErr: false,
      from_date:"",
      to_date : ""

    })
    if (date) {
      Packed_From_Date_val = this.convertDate(date);
      From_Date_val = "";
    to_Date_val = "";
    } else {
      this.setState({
        packedfromdate: ""
      })
      Packed_From_Date_val = "";
      From_Date_val = "";
    to_Date_val = "";
    }


  }

  PackedToDateChange = date => {

    this.setState({
      packedtodate: date,
      showToErr: false
    })
    if (date) {
    Packed_to_Date_val = this.convertDate(date);
    From_Date_val = "";
    to_Date_val = "";
    } else {
      this.setState({
        pakcedtodate: "",

      })
      Packed_to_Date_val = "";
      From_Date_val = "";
    to_Date_val = "";
    }

  }
  onInvoiceChange = (evt) => {
    this.setState({
      invoice_no: evt.target.value,
    });
  };
  onTripChange = (evt) => {
    this.setState({
      trip_id: evt.target.value,
    });
  };
  onProductChange = (evt) => {
    this.setState({
      product_code: evt.target.value,
    });
  };

  onwarehouseChange = (evt) => {

    this.setState({
      warehouse_code: evt.target.value
    })

  }

  onBrandChange = (evt) => {

    this.setState({
      brand_code: evt.target.value
    })

  }


  fetchWarehouseData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          warehouseData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchBrandData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/client/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          clientData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchSalesData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      fromdate: From_Date_val,
      todate: to_Date_val,
      packed_from_date:Packed_From_Date_val,
      packed_to_date : Packed_to_Date_val,
      invoice_no: this.state.invoice_no,
      trip_id: this.state.trip_id,
      product_code: this.state.product_code,
      warehouse: this.state.warehouse_code,
      brand: this.state.brand_code
    };
    API.post('/mis/salesreturntogrreports/v1/', { param: payload })
      .then(response => response.data)

      .then(data => {

        this.setState({ tableRows: this.assemblePosts(data.data), })

      })

      .then(async () => {

        this.setState({ isLoading: false })



      });
  }
  downloadReport() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      request_type : "download",
      fromdate: From_Date_val,
      todate: to_Date_val,
      packed_from_date:Packed_From_Date_val,
      packed_to_date : Packed_to_Date_val,
      invoice_no: this.state.invoice_no,
      trip_id: this.state.trip_id,
      product_code: this.state.product_code,
      warehouse: this.state.warehouse_code,
      brand: this.state.brand_code
    };
    API.post('/mis/salesreturntogrreports/v1/', { param: payload })
      .then(response => response.data)

      .then(data => {

        window.location.href = data.data[0]
        this.setState({loading_overlay: false})
      })

      .then(async () => {

        this.setState({ isLoading: false })



      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
          warehouse: post.warehouse,
          client: post.client,
          invoice_no: post.invoice_no,
          trip_id: post.trip_id,
          bill_number: post.bill_number,
          srn_date: post.srn_date,
          confirm_datetime : post.confirm_datetime,
          product_code: post.product_code,
          product_name: post.product_name,
          mrp: post.mrp,
          return_qty_landed: post.return_qty_landed,
          return_qty_received: post.return_qty_received,
          return_qty_putaway_done: post.return_qty_putaway_done,
          return_qty_gr_done: post.return_qty_gr_done,
          return_qty_gr_value: post.return_qty_gr_value,
          tax_amount: post.tax_amount,
          tax_percentage: post.tax_percentage,
          taxable_value: post.taxable_value,
          retailer_name: post.retailer_name,
          retailer_code: post.retailer_code,
          return_value: post.return_value,




        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts,
      orderData: posts,
      filtered_orderData: posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {

    const data = {

      columns: [
        {
          label: ' Warehouse',
          field: 'warehouse',
          sort: 'asc',
          width: 120,

        },

        {
          label: ' Client',
          field: 'client',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Invoice Number',
          field: 'invoice_no',
          sort: 'asc',
          width: 240,

        },
        {
          label: 'Trip Id',
          field: 'trip_id',
          sort: 'asc',
          width: 180,

        },
        {

          label: 'Bill Number',
          field: 'bill_number',
          width: 140,
          sort: 'asc',

        },
        {
          label: ' SRN Date',
          field: 'srn_date',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Confirm Datetime',
          field: 'confirm_datetime',
          sort: 'asc',
          width: 170,

        },


        {
          label: 'Product Code',
          field: 'product_code',
          width: 140,
          sort: 'asc',

        },
        {
          label: 'Product Name',
          field: 'product_name',
          width: 180,
          sort: 'asc',

        },
        {

          label: 'MRP',
          field: 'mrp',
          width: 140,
          sort: 'asc',

        },

        {
          label: 'Return qty- Landed',
          field: 'return_qty_landed',
          width: 140,
          sort: 'asc',

        },


        {

          label: 'Return qty- Received',
          field: 'return_qty_received',
          width: 140,
          sort: 'asc',

        },

        {

          label: 'Return qty- Putaway Done',
          field: 'return_qty_putaway_done',
          width: 140,
          sort: 'asc',

        },

        {

          label: 'Return qty- GR Done',
          field: 'return_qty_gr_done',
          width: 140,
          sort: 'asc',

        },

        {

          label: 'Return qty- GR value',
          field: 'return_qty_gr_value',
          width: 140,
          sort: 'asc',

        },
        {
          label: "Tax Amount",
          field: "tax_amount",
          width: 140,
          sort: 'asc'
        },
        {
          label: " Tax %",
          field: "tax_percentage",
          width: 140,
          sort: 'asc'
        },

        {
          label: "Taxable Value",
          field: "taxable_value",
          width: 140,
          sort: 'asc'
        },

        {
          label: "Retailer Name",
          field: "retailer_name",
          width: 140,
          sort: 'asc'
        },
        {
          label: "Retailer Code",
          field: "retailer_code",
          width: 140,
          sort: 'asc'
        },
        {
          label: "Return value",
          field: "return_value",
          width: 140,
          sort: 'asc'
        }



      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody style={{ paddingTop: 5, height: 150, paddingBottom: 0 }}>
            <form className="form" >

            <div style={{ marginBottom: '3px', float: 'left', marginRight: 10, border: "1px solid rgba(0, 0, 0, 0.125)",borderRadius : "4px"}}>
            <p style={{marginLeft:5}}>SO Creation Date</p>
              <div style={{  marginBottom: '5px', float: 'left', marginRight: 8, marginLeft:5}}>
                
                <DatePicker
                  selected={this.state.from_date}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format='yyyy-MM-dd'
                />
                {this.state.showFromErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                }
              </div>
              <div style={{ marginBottom: '3px', float: 'left', marginRight: 5, }}>
                <DatePicker
                  selected={this.state.to_date}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  styles ={{height: '36px!important'}}
                  placeholderText="To Date"
                />
                {this.state.showToErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                }
              </div>
              </div>
              <div style={{marginRight: 8,marginTop: 22}}>
                <p>OR</p>
              </div>
              <div style={{ marginBottom: '3px', float: 'left', marginRight: 10, border: "1px solid rgba(0, 0, 0, 0.125)",borderRadius : "4px"}}>
            <p style={{marginLeft:5}}>Packed Date</p>
              <div style={{  marginBottom: '5px', float: 'left', marginRight: 5, marginLeft:5}}>
                
                <DatePicker
                  selected={this.state.packedfromdate}
                  onChange={this.PackedFromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format='yyyy-MM-dd'
                />
                {this.state.showFromErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                }
              </div>
              <div style={{ marginBottom: '3px', float: 'left', marginRight: 5, }}>
                <DatePicker
                  selected={this.state.packedtodate}
                  onChange={this.PackedToDateChange}
                  className="ledger_todate"
                  styles ={{height: '36px!important'}}
                  placeholderText="To Date"
                />
                {this.state.showToErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                }
              </div>
              </div>
              <div style={{ marginBottom: '10px', float: 'left', marginRight: 10, }}>
              <div
                style={{ width: '160px', marginBottom: '3px', float: 'left', marginRight: 5 }}
              >
                <div
                  className="form__form-group-field"

                >
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Invoice Number" onChange={this.onInvoiceChange} />
                </div>
              </div>
              <div
                style={{ width: '160px',marginBottom: '0px', float: 'left', marginRight: 5 }}
              >
                <div
                  className="form__form-group-field"

                >
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Trip Id" onChange={this.onTripChange} />
                </div>
              </div>
              <div
                style={{ width: '160px', marginBottom: '0px', float: 'left', marginRight: 5 }}
              >
                <div
                  className="form__form-group-field"

                >
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Product code" onChange={this.onProductChange} />
                </div>
              </div>

              <div
                style={{ width: '160px', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control"
                    style={{ fontSize: 13, width: 160 }}
                    onChange={this.onwarehouseChange}
                  >
                    <option value="">Select warehouse</option>
                    {
                      this.state.warehouseData.length > 0 &&
                      this.state.warehouseData.map((warehouseData) => {
                        return (
                          <option value={warehouseData.name}>{warehouseData.name} </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                style={{ width: '160px', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control"
                    style={{ fontSize: 13, width: 160 }}
                    onChange={this.onBrandChange}
                  >
                    <option value="">Select Brand</option>
                    {
                      this.state.clientData.length > 0 &&
                      this.state.clientData.map((clientData) => {
                        return (
                          <option value={clientData.name}>{clientData.name} </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div style={{ marginRight: "15px",marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchSalesData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                </ButtonToolbar>
              </div>
              <div style={{ marginBottom: '0px', float: 'left' }}>
                <Button type="button" className="btn btn-primary-outline"
                  style={{
                    cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                    backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                  }}
                  id="button_enable"
                onClick={this.downloadReport}
                >

                  <img src={require('../../../../images/download.png')} onClick={this.state.downloadReport} />
                  {/* <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, "Sales Return To Gr Report")} /> */}
                </Button>
              </div>
              </div>

            </form>
          </CardBody>
          {
            this.state.showFetchBinData && (
              <CardBody style={{ marginTop: 4, paddingTop: 0, paddingBottom: 0 }}>
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -10 }}
              ></div>

                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={data}
                // style={{ textAlign: "center" }}
                />
              
              </CardBody>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));